export default __webpack_public_path__ + "static/media/pricing-notice.25602f76.png";